<p-messages severity="warn">
  <ng-template pTemplate>
    <div class="w-full text-center">
      {{ "ERROR.RESOURCE-NOT-FOUND" | translate }}
    </div>
  </ng-template>
</p-messages>
